import jQuery from 'jquery';
import React from 'react';
import Dropdown from './ui/Dropdown.jsx';
import CheckboxList from './ui/CheckboxList.jsx';
import Image from './ui/Image.jsx';
import Button from './ui/button/Button.jsx';
import styles from './Configurator.styl';

/**
 * Базовый класс для конфигураторов
 */
class Configurator extends React.Component {
	constructor(props) {
		super(props);

		if (!this.getType) {
			throw 'Method Configurator.getType is not implemented';
		}

		if (!this.getCustomStyles) {
			throw 'Method Configurator.getCustomStyles is not implemented';
		}

		this.db = null;
		this.filter = {};

		this.state = {
			filters: {},
			articles: [],
			item: null
		};

		this.onBtnPrintClick = this.onBtnPrintClick.bind(this);
		this.onBtnPrintPdfClick = this.onBtnPrintPdfClick.bind(this);
		this.onBtnCartClick = this.onBtnCartClick.bind(this);
		this.onListItemCheck = this.onListItemCheck.bind(this);
	}

	componentDidMount() {
		this.loadDb();
	}

	applyFilters(subListName = null) {
		const itemList = (subListName ? this.db.list[subListName] : this.db.list);
		const filterKeys = Object.keys(this.filter);

		if (filterKeys.length === 0) {
			return itemList;
		}

		return itemList.filter(item => {
			return filterKeys.every(filterPropName => {
				return (Array.isArray(item[filterPropName]) ?
					item[filterPropName].indexOf(this.filter[filterPropName]) !== -1
					: item[filterPropName] === this.filter[filterPropName]);
			});
		});
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;

				// if (this.getType() === 'enclosure') {
				// 	db.filter.series.splice(1, 1)
				// 	db.list.splice(334, 86)
				// }//временное удаление линейки LINEA S

				const items = this.applyFilters();
				const articles = items.map(item => {
					return item.article;
				});

				if ('filter' in db) {
					Object.keys(db.filter).forEach(filterName => {
						db.filter[filterName].unshift('Все');
					});
				} else {
					db.filter = [];
				}

				this.setState({
					filters: db.filter,
					articles
				});

				this.onAfterDbLoad();
			}
		);
	}

	onAfterDbLoad() {
	}

	doPrint(params) {
		const _params = params || {};
		const $postForm = jQuery('<form action="print.php" method="post" target="_blank" accept-charset="UTF-8" />');

		let addHiddenField = function (name, value) {
			jQuery('<input type="hidden" />').attr('name', name).val(value).appendTo($postForm);
		};

		addHiddenField('type', this.getType());

		if (this.state.item && this.state.item.article) {
			addHiddenField('article', this.state.item.article);
		}

		if (_params.data) {
			Object.keys(_params.data).forEach(dataItemName => {
				addHiddenField(dataItemName, _params.data[dataItemName]);
			});
		}

		if (_params.format) {
			addHiddenField('format', _params.format);
		}

		if (this.props.locale) {
			addHiddenField('locale', this.props.locale);
		}

		$postForm.appendTo('body').submit().remove();
	}

	doAddToCart(items) {
		const goods = JSON.stringify(
			{
				products: items.map(i => (
					{
						cnt: i.count || 1,
						art: i.article || i.art,
						name: i.name,
					}
				))
			}
		)
		// Отправка JSON в ipro
		window.top.postMessage(goods, '*')

	}

	onBtnPrintClick() {
		this.doPrint();
	}

	onBtnCartClick() {
		this.doAddToCart([this.state.item]);
	}

	onBtnPrintPdfClick() {
		this.doPrint({format: 'pdf'});
	}

	onFilterChange(prop, value) {
		if ('Все' === value) {
			delete this.filter[prop];
		} else {
			this.filter[prop] = value;
		}

		this.updateList();
	}

	onListItemCheck(value) {
		if (this.state.item && (value === this.state.item.article)) {
			return;
		}
		if(this.getType()==='enclosure'
			|| this.getType()==='lan'
			|| this.getType()==='optic'
			|| this.getType()==='power'
			|| this.getType()==='ground_select'
		){
			jQuery.getJSON(
				'itkcfg.php',
				{
					type: this.getType(),
					action: 'getItemNSI',
					article: value
				},
				itemInfo => {
					this.setState({itemInfo});
					if (this.getType() === 'enclosure') {
						this.doAddToCart(itemInfo)
					}
				}
			)
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItem',
				article: value
			},
			item => {
				this.setState({item});
				if (this.getType() === 'pigtail' || this.getType() === 'patchcord' || this.getType() === 'electTechCloset') {
					let items = []
					items.push(item)
					this.doAddToCart(items)
				}
			}
		);
	}

	updateList() {
		const items = this.applyFilters();

		const articles = items.map(item => {
			return item.article;
		});

		this.setState({
			articles: articles
		});

		this.onListItemCheck(articles[0]);
	}

	buildDropdownFilters(_params) {
		const params = _params ? _params : {};
		const customStyles = this.getCustomStyles();
		const filterTitles = (this.getFilterTitles ? this.getFilterTitles() : null);
		const stateFilters = this.state.filters;

		let dropDownFilters = [];

		Object.keys(stateFilters).forEach(filterName => {
			if (params.skip && params.skip.indexOf(filterName) !== -1) {
				return;
			}

			let filterItems = [stateFilters[filterName][0]];

			stateFilters[filterName].forEach((filterItemValue, filterItemIndex) =>
			{
				// Пропускаем "Все"
				if (filterItemIndex === 0) {
					return;
				}

				let prevFilterValue = this.filter[filterName];

				if (prevFilterValue) {
					// Какие варианты, если бы фильтр не был применен
					delete this.filter[filterName];
				}

				let itemList = this.applyFilters();

				const articles = itemList.map(item => {
					return item.article;
				});

				for (let itemIndex in itemList) {
					let item = itemList[itemIndex];

					if (articles.indexOf(item.article) === -1) {
						continue;
					}

					if (Array.isArray(item[filterName]) ? item[filterName].indexOf(filterItemValue) !== -1 : item[filterName] === filterItemValue) {
						filterItems.push(filterItemValue);
						break;
					}
				}

				if (prevFilterValue) {
					this.filter[filterName] = prevFilterValue;
				}
			});

			const dropDownProps = {
				key: filterName,
				className: customStyles['filter_' + filterName],
				items: filterItems,
				value: (this.filter[filterName] ? this.filter[filterName] : filterItems[0]),
				title: (filterTitles && filterTitles[filterName] ? filterTitles[filterName] : null),
				onItemChange: (value) => this.onFilterChange(filterName, value)
			};

			if (params.filterLabels) {
				dropDownProps.label = params.filterLabels[filterName];
			}

			dropDownFilters.push(<Dropdown {...dropDownProps} />);
		});

		return dropDownFilters;
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	delDuplicatesFromArray(array) {
		let seen = {};
		return array.filter(function (item) {
			let k = JSON.stringify(item);
			return seen.hasOwnProperty(k) ? false : (seen[k] = true);
		})
	}

	render() {
		const customStyles = this.getCustomStyles();
		let type=this.getType()
		if (!this.db) {
			return <div className={customStyles.cfg}></div>;
		}


		return (
			<div className={customStyles.cfg}>
				{this.getCustomElements ? this.getCustomElements() : null}

				{this.buildDropdownFilters()}

				<div className={customStyles.articleCount ? customStyles.articleCount : styles.articleCount}>Артикул:</div>

				<CheckboxList
					items={this.state.articles}
					selectedValue={this.state.item ? this.state.item.article : null}
					onItemCheck={this.onListItemCheck}
				/>

				{/* Артикул и имя */}
				{this.state.item ? (
					<div className={styles.name}>
						<div><strong>{this.state.item.article}</strong></div>
						<div>{this.state.item.name}</div>
					</div>
				) : (
					<div className={styles.nameEmpty}></div>
				)}

				{/* Описание */}
				{type=='enclosure'?<div></div>: this.state.item && this.state.item.description ? (
					<div className={styles.description}>{this.state.item.description}</div>
				) : (
					<div className={styles.descriptionEmpty}></div>
				)}
				{type=='enclosure'?<div></div>:
				<Image
					className={styles.itemImage}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
				/>}

				<Button
					buttonStyle={customStyles.btnPdf ? customStyles.btnPdf : styles.btnPdf}
					buttonDisabledStyle={customStyles.btnPdfDisabled ? customStyles.btnPdfDisabled : styles.btnPdfDisabled}
					iconStyle={styles.btnPdfIcon}
					text="Сохранить в PDF"
					disabled={!this.state.item}
					onClick={this.onBtnPrintPdfClick}
				/>
				<Button
					buttonStyle={customStyles.btnPrint ? customStyles.btnPrint : styles.btnPrint}
					buttonDisabledStyle={customStyles.btnPrintDisabled ? customStyles.btnPrintDisabled : styles.btnPrintDisabled}
					iconStyle={styles.btnPrintIcon}
					text="Распечатать"
					disabled={!this.state.item}
					onClick={this.onBtnPrintClick}
				/>
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '710px'}}/>
				<a className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#76d750',
					width: '50%',
					height: '22px',
					top: '710px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '714px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-24</span>
			</div>
		);
	}
}

export default Configurator;


if (typeof String.prototype.endsWith !== 'function') {
	String.prototype.endsWith = function (suffix) {
		return this.indexOf(suffix, this.length - suffix.length) !== -1;
	};
}

if (!Object.assign) {
	Object.defineProperty(Object, 'assign', {
		enumerable: false,
		configurable: true,
		writable: true,
		value: function (target, firstSource) {
			'use strict';
			if (target === undefined || target === null) {
				throw new TypeError('Cannot convert first argument to object');
			}

			var to = Object(target);
			for (var i = 1; i < arguments.length; i++) {
				var nextSource = arguments[i];
				if (nextSource === undefined || nextSource === null) {
					continue;
				}

				var keysArray = Object.keys(Object(nextSource));
				for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
					var nextKey = keysArray[nextIndex];
					var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
					if (desc !== undefined && desc.enumerable) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
			return to;
		}
	});
}

if (!Object.entries) {
	Object.entries = function (obj) {
		var ownProps = Object.keys(obj),
			i = ownProps.length,
			resArray = new Array(i); // preallocate the Array
		while (i--)
			resArray[i] = [ownProps[i], obj[ownProps[i]]];

		return resArray;
	};
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
		value: function (predicate) {
			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		},
		configurable: true,
		writable: true
	});
}



// WEBPACK FOOTER //
// ./src/react/Configurator.jsx